
export default {
  banner: 'https://qishimai-1257428522.file.myqcloud.com/website/other/custommade_top_bg.png',
  bannerSteps: [
    {
      label: '提交需求',
      image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/customize_icon/demand.png'
    },
    {
      label: '电话沟通',
      image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/customize_icon/phone.png'
    },
    {
      label: '确认方案',
      image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/customize_icon/determine.png'
    },
    {
      label: '快乐出行',
      image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/customize_icon/travel.png'
    },
  ],
  service: {
    text: '定制一场懂你的旅行，无须跟团或做攻略，享受惬意人生的无穷快乐！',
    steps: [
      {
        name: '1对1定制',
        content: '专业定制师根据您的需求，定制专属方案',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/service_steps/1v1.png'
      },
      {
        name: '定制路书',
        content: '不用费力做攻略，行程宽松您说了算',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/service_steps/custommade.png'
      },
      {
        name: '代订资源',
        content: '机票/酒店/用车/向导/门票等资源代订',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/service_steps/subscribe.png'
      },
      {
        name: '透明报价',
        content: '价格透明，品牌保证好的定制，专属于你',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/service_steps/quotation.png'
      },
      {
        name: '出行保障',
        content: '在线导游7*24h行中应急保障全年无休',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/service_steps/guarantee.png'
      },
    ]
  },
  customizer: {
    text: 'Ta们拥有专业知识、热情、耐心周到～Ta们懂旅行，也更懂你',
    memberlist: [
      {
        name: 'Steven',
        intro: '擅长目的地：新疆、西藏、云贵川 个人爱好：足球、徒步、户外活动、露营',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/other/customizer_steven.png',
        experience: '20年旅行经验',
        content: '一个有深度旅行情怀的人。大学毕业，别人都去北京上海这些大城市搞旅游赚钱。史同学居然选择了援藏，而且是西藏最艰苦的阿里地区。20天的徒步转山团可以套着上，以至于经常被人误以为是夏尔巴人。援藏结束后，长年带着一帮老外出没在新疆和藏区。您要是喜欢自然风光路线，找他就对了！'
      },
      {
        name: '曹楠',
        intro: '擅长目的地：西班牙、葡萄牙、南美洲、新疆、西藏、青海、甘肃、陕西等地。',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/other/customizer_caonan.png',
        experience: '20年旅行经验',
        content: '西班牙语导游/领队。2005年曾随家人移居西班牙，期间在西班牙的加纳利亚群岛生活过两年，随后于2008年在西班牙本土经营自己的咖啡馆。在西班牙居住期间，曾多次自驾游览欧洲各国，熟知当地交规，有着丰富的海外生活和自驾经验。同时，他也是资深西甲球迷，欢迎喜欢西甲的朋友和他交流~'
      },
      {
        name: 'Ana',
        intro: '擅长目的地：福建、广东、云贵川、甘肃、青海',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/other/customizer_ana.png',
        experience: '10年旅行经验',
        content: '毕业于澳大利亚格里菲斯大学旅游与酒店管理专业，曾在国内著名旅游网站担任澳洲美食、特色酒店及民宿编辑一职。Ana喜欢慢节奏的深度旅行，喜欢探索一个目的地的角角落落，目前已参与编写路书200多本。'
      },
      {
        name: '竹子',
        intro: '擅长目的地：新疆、西藏、云贵川',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/other/customizer_zhuzi.png',
        experience: '10年旅行经验',
        content: '曾梦想仗剑走天涯，谁知方向盘打了滑~留英金融硕士做了旅游。不论是奢华放纵还是柴米油盐，不论是飞机火车还是四轮驾车~都能给您最满意的行程。'
      },
    ]
  }
}


// WEBPACK FOOTER //
// ./src/utils/staticData/customizeData.js